import { gql } from "@apollo/client";

export const GET_EVENTS_LIST_QUERY =gql `
query GetEvents($filter: EventFilterOptions, $sort: [SortOptions], $pageOptions: PageOptions) {
  getEventsWithPagination(filter: $filter, sort: $sort, pageOptions: $pageOptions) {
    events{
          arcimedes_row_id
          title
          text
          date
          deleted
        }
        totalCount
  }
}`;

export const GET_EVENT_QUERY = gql`
  query GetEvent($arcimedesRowId: ID!) {
    getEvent(arcimedes_row_id: $arcimedesRowId) {
        arcimedes_row_id
        title
        text
        date
        deleted
  }
}
`;

export const CREATE_OR_UPDATE_EVENT = gql`
  mutation CreateOrUpdateEvent($input: EventsInput) {
    createOrUpdateEvent(input: $input) {
      success
      message
      event {
        arcimedes_row_id
        title
        text
        date
        deleted
      }
      error
    }
}`